import { connect } from 'react-redux';
import { getDashboardFeaturesSelector } from '@/store/dashboard/dashboard.selectors';

export default (mapState?: (mapped: any, state: any, props: any) => any) => {
  const featuresSelector = getDashboardFeaturesSelector();

  const mapStateToProps = (state: any, props: any) => {
    const features = featuresSelector(state, props);

    const mapped = {
      isFeatureCan: !!features[props.feature],
      features,
    };
    return mapState ? mapState(mapped, state, props) : mapped;
  };
  return connect(mapStateToProps);
};
